<template>
    <div>
<!--        <section id="refine-search">-->
<!--            <button type="button" id="button-refine-search" class="collapsed" data-toggle="collapse"-->
<!--                    data-target="#refine-search-form" aria-expanded="false" aria-controls="refine-search-form">-->
<!--                Show Refine Search-->
<!--                <span class="arrow">-->
<!--                    <img src="../../images/collapse.svg" alt="Collapse">-->
<!--                </span>-->
<!--            </button>-->
<!--            <div class="grey collapse" id="refine-search-form">-->
<!--                <div class="container">-->
<!--                    <div class="row">-->
<!--                        <div class="col-md-12">-->
<!--                            <form action="" class="refine-search" id="refineSearch" method="GET">-->
<!--                                <refine-search-->
<!--                                    :searchfields="searchfields"-->
<!--                                    @searchHandler="onSearch"-->
<!--                                />-->
<!--                            </form>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
<!--        </section>-->
        <section id="result-search-page">
            <div :class="containerClasses">
                <div class="row">
                    <div class="search-result-top">
                        <div class="top">
                            <div class="left">
                                <h2 @click.alt.shift.right="favouriteAll">
                                    <template v-if="past">
                                        Past search results
                                    </template>
                                    <template v-else>
                                        Search results
                                    </template>
                                </h2>
                            </div>
                        </div>

                        <div v-if="hasActiveRecommends" class="view-recommends-notif highlight">
                            <router-link to="/recommended">
                                <span class="icon-submenu">
                                    <img src="/images/favourites-full.svg" alt="Recommended">
                                </span>
                                View your recommended vehicles
                            </router-link>
                        </div>

                        <div class="bottom space-between">
                            <div class="left">
                                <span class="showing">
                                    <strong>Showing</strong>
                                    <span>{{ startFrom }}</span>-<span>{{ endNumber }}</span> of <span>{{ totalRecords }}</span>
                                    results
                                </span>
                                <!--<a class="link select-all" @click="toggleSelectAll">{{selectAllText}}</a>-->
                                <a v-if="perPage !== 500" class="link show-max" @click="showMax()">Max</a>
                                <select class="per-page" v-model="perPage" @change="getData();setSearchSettings();">
                                    <option v-for="option in per_page_options" :value="option.value">
                                        {{ option.text }}
                                    </option>
                                </select>
                                <select class="per-row" v-model="perRow" @change="setSearchSettings()">
                                    <option v-for="option in vehicles_in_row_options" :value="option.value">
                                        {{ option.text }}
                                    </option>
                                </select>
                            </div>
                            <div class="right">
                                <select name="sorting" id="sorting" @change="getSortOrderBy()"
                                        v-model="sortOrderBy">
                                    <option value="make" selected>Sort by make</option>
                                    <option value="model">Sort by model</option>
                                    <option value="a_price">Price low to high</option>
                                    <option value="d_price">Price high to low</option>
                                    <option value="time">Auction time</option>
                                    <option value="a_year">Year low to high</option>
                                    <option value="d_year">Year high to low</option>
                                    <option value="d_condition">Auction grade high to low</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-lg-3 col-md-3 col-12 pull-right">
                            <b-pagination v-if="totalRecords > (currentPage - 1) * perPage" align="right" :total-rows="totalRecords" v-model="currentPage"
                                          :per-page="perPage"></b-pagination>
                        </div>
                        <div class="col-lg-3 col-md-3 col-12" v-if="notSeenBefore">
                            <div class="row">
                                <span class="text-danger">{{notSeenBefore}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="container-results" id="container-results">
                        <Vehicle v-if="results.length" v-for="vehicle of results" :key="vehicle.api_id"
                                 :vehicle="vehicle"
                                 :priceField="priceField"
                                 :selected="selectedVehicles.indexOf(vehicle.api_id) !== -1"
                                 @select="selectVehicle"
                                 @tagPopupModal="tagPopupModal">
                        </Vehicle>
                        <div v-if="!results.length && !loading" class="ml-4">
                            No results containing all your search were found
                        </div>
                        <div class="single-result-search none"
                             v-for="vehicle of [1,2,3,4,5,6,7,8]"></div>
                        <div v-if="loading" class="container-results" id="loading-results">
                            <img src="/images/loading.svg" alt="Loading..." class="loader"/>
                        </div>
                    </div>
                    <div class="bottom-container-result d-flex flex-wrap">
                        <div class="col-lg-3 col-md-2 col-12">
                            <!--<a class="link select-all" @click="toggleSelectAll">{{selectAllText}}</a>-->
                            <a v-if="perPage !== 500" class="link show-max" @click="showMax()">Max</a>
                        </div>
                        <div class="col-lg-6 col-md-7 col-12 button-down-search-result">
                            <a href="#" @click="emailModelOpen = true" class="btn">Send Email</a>
                            <a href="#" v-b-modal.saveSearch class="btn">Save Search</a>
                            <a v-if="$userIsAdmin()" href="#" @click="recommendModelOpen = true" class="btn">Recommend</a>
                            <a href="" class="btn" @click.prevent="addAutoNotice">Auto Notice</a>
                        </div>
                        <div class="col-lg-3 col-md-3 col-12">
                            <b-pagination v-if="totalRecords > (currentPage - 1) * perPage" align="right" :total-rows="totalRecords" v-model="currentPage"
                                          :per-page="perPage" @change="getPagination()"></b-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <b-modal id="saveSearch" title="Save search" @ok="saveSearchFunc()" @hidden="saveSearchData.name = ''">
            <b-form-input v-model="saveSearchData.name" placeholder="Enter search name"></b-form-input>
        </b-modal>
        <vehicle-recommendation-modal :notifyMessage="recommendMessageSendEmail" :selectedVehicles="vehicleIds" :cacheKey="resultCacheKey" v-model="recommendModelOpen" :recommend="true"></vehicle-recommendation-modal>
        <vehicle-recommendation-modal :notifyMessage="notifyMessageSendEmail" :selectedVehicles="vehicleIds" :cacheKey="resultCacheKey" v-model="emailModelOpen" :recommend="false"></vehicle-recommendation-modal>
        <favourite-tag-modal
                :vehicleId=vehicle_id
                v-model="favListModalOpen"
                :date="date"
                @changed="onTagChanged"
        ></favourite-tag-modal>
    </div>
</template>
<script>
    import moment from "moment-timezone";
    import refineSearch from './RefineSearch.vue';
    import {getterSetter} from '../util/vuex_setter_getter'
    import Vehicle from './Common/Vehicle';
    import {mapState, mapActions, mapMutations} from 'vuex'
    import {
        handleHttpError,
        getExceptionErrorMessage,
        objToUrl,
        numberWithCommas,
        getDateTime,
        getNZDateTime,
        getJapanDiff,
        setBackToAll,
        objLookup,
        addPageUrlParam,
    } from '../util/common'

    const currentUser = window.loggedInUser;

    export default {
        props: [
            'searchfields',
            'past',
        ],
        components: {
            'refine-search': refineSearch,
            Vehicle
        },
        created() {
            this.setLoading(false);
            this.getSearchSettings();
            if (this.$route.query.sort_by) {
                this.sortOrderBy = this.$route.query.sort_by
            }
            this.$nextTick(() => {
                this.$store.dispatch('auction_nextprev/checkStack');
                if (this.$route.query.cache_key) {
                    this.getData(this.$route.query.cache_key);
                } else {
                    this.getData();
                }
            })
        },
        mounted() {
            if (!this.$route.query.page) {
                addPageUrlParam(this.currentPage, this.$router, true)
            }
            this.$nextTick(() => {
                this.$store.dispatch('auction_nextprev/checkListReturn', this.$route.query.state_key || null)
            });
        },
        data() {
            return {
                saveSearchData: this.searchfields,
                showSearchBidBox: true,
                recommendModelOpen: false,
                emailModelOpen: false,
                vehicleIds: [],
                perRow: 0,
                totalRecords: 0,
                favListModalOpen: false,
                resultCacheKey: null,
                vehicleList: [],
                sortOrderBy: 'make',
                selected: {},
                translatedGrades: {},
                isCurrentSelected: false,
                searchFieldData: '',
                bid: '',
                tags: [],
                vehicle_id: '',
                sbl_vehicle_id: '',
                notSeenBefore: false,
                priceField: this.past ? 'end_price' : 'start_price',
                vehicles_in_row_options: [
                    {value: 0, text: 'FULL WIDTH'},
                    {value: 5, text: '5 per row'},
                    {value: 6, text: '6 per row'},
                ],
                per_page_options: [
                    {value: 50, text: '50 per page'},
                    {value: 100, text: '100 per page'},
                    {value: 250, text: '250 per page'},
                    {value: 500, text: '500 per page'},
                ],
                dataRetrievalCancelTokenSource: null,
                notifyMessageSendEmail: 'We’ve hand-picked some vehicles in the upcoming auctions that may work for you. Get in touch with me for more information on any of these vehicles',
                recommendMessageSendEmail: "I’ve hand-picked some vehicles that are going through auctions today that I hope you like. \n\n Look forward to seeing your bids soon. 🚗 😀 🥇",
                hasActiveRecommends: currentUser.has_active_recommends,
            }
        },
        computed: {
            ...mapState({
                loading: state => state.auction_search.loading,
                selected_models: state => state.auction_search.selected_models,
                loadVehicles: state => state.loadVehicleForEmail.all,
            }),
            results: {
                get(){
                    const url_state_key = this.$route.query && this.$route.query.state_key ? this.$route.query.state_key : null;
                    if (url_state_key && this.$store.getters['auction_search/getSearchResultsStateKey'] === url_state_key) {
                        return this.$store.getters['auction_search/getSearchResults']
                    }
                    const state_key = window.history.state && window.history.state.key ? window.history.state.key : null;
                    if (state_key && this.$store.getters['auction_search/getSearchResultsStateKey'] === state_key) {
                        return this.$store.getters['auction_search/getSearchResults']
                    }
                    return []
                },
                set(value){
                    const state_key = window.history.state && window.history.state.key ? window.history.state.key : null;
                    this.$store.commit('auction_search/setSearchResultsStateKey', state_key)
                    this.$store.commit('auction_search/setSearchResults', value)
                }
            },
            selectedVehicles: new getterSetter('auction_search/getSelectedVehicles', 'auction_search/setSelectedVehicles'),
            resultBlockWidth() {
                if (this.perRow) {
                    return {
                        width: 'calc(' + 100 / this.perRow + '% - 5px)'
                    }
                }
                return '';
            },
            date(){
                if (this.searchfields && this.searchfields.dates) {
                    return this.searchfields.dates;
                }
                return null
            },
            containerClasses() {
                let classes = ['container'];
                if (this.perRow === 0) {
                    classes.push('full-width');
                } else if (this.perRow === 5) {
                    classes.push('per-5');
                } else if (this.perRow === 6) {
                    classes.push('per-6');
                }
                return classes.join(' ');
            },
            currentPage: {
                get () {
                    return this.$store.getters['auction_search/getCurrentPage']
                },
                set (value) {
                    this.$store.commit('auction_search/setCurrentPage', value)
                    addPageUrlParam(value, this.$router)
                }
            },
            perPage: {
                get () {
                    return this.$store.getters['auction_search/getPerPage']
                },
                set (value) {
                    this.$store.commit('auction_search/setPerPage', value)
                }
            },
            startFrom () {
                return (this.currentPage - 1) * this.perPage + 1;
            },
            endNumber () {
                let endNumber = this.perPage * this.currentPage
                if (endNumber > this.totalRecords) {
                    endNumber = this.totalRecords
                }
                return endNumber
            },
            pageParam () {
                return this.$route.query.page
            }
        },
        methods: {
            ...mapActions({
                storeToggleFavourite: 'favourites/toggleFavourite',
                saveSearch: 'saved_searches/saveSearch',
                translateGrades: 'auction_search/translateGrades',
                checkStack: 'auction_nextprev/checkStack',
                checkListReturn: 'auction_nextprev/checkListReturn',
                addToNextPrevStack: 'auction_nextprev/addToStack',
            }),
            ...mapMutations({
                setLoading: 'auction_search/setLoading',
            }),
            numberWithCommas,
            getDateTime,
            getNZDateTime,
            getJapanDiff,
            onTagChanged(data){
                let selected = this.selectedVehicles.indexOf(data.vehicle_id);
                if (data.removed) {
                    if (data.tags_left === 0 && selected !== -1) {
                        this.selectedVehicles.splice(selected, 1);
                    }
                } else {
                    if (selected === -1) {
                        this.selectedVehicles.push(data.vehicle_id);
                    }
                }
            },
            /**
             * This is secret functionality, mainly to make it easier to test
             * @returns {Promise<void>}
             */
            async favouriteAll(){
                await this.axios.post(this.$laravelRoute('favourite.bulk'), {vehicles: this.results})
                this.$message('All cars have been added to favourites');
            },
            log() {
                console.log(arguments);
            },
            getPagination() {
                this.$nextTick(() => {
                    this.getData();
                })
            },
            saveSearchFunc(){
                let data = JSON.parse(JSON.stringify(this.saveSearchData));
                if (Object.keys(this.selected_models).length) {
                    let models = ''
                    let i = 0
                    for (let make in this.selected_models) {
                        if (i > 0) {
                            models += '|';
                        }
                        let n = 0;
                        for (let model in this.selected_models[make]) {
                            if (this.selected_models[make][model]) {
                                if (n > 0) {
                                    models += ',';
                                }
                                models += model;
                                n++
                            }
                        }
                        i++;
                    }
                    data.model = models
                }
                this.saveSearch(data)
            },
            showTip(event) {
                var container = $(event.target).parent();
                container.find('.tip').css('transform', 'scaleY(1)');
            },
            hideTip() {
                var container = $(event.target).parent().parent().parent();
                container.find('.tip').css('transform', 'scaleY(0)');
            },
            setSearchSettings() {
                let data = {
                    vehicle_search_per_page: this.perPage,
                    vehicle_search_per_row: this.perRow,
                };

                this.axios.post(this.$laravelRoute('set-search-settings'), data);
            },
            getSearchSettings() {
                if (this.loggedInUser && this.loggedInUser.search_settings){
                    this.perPage = this.loggedInUser.search_settings.vehicle_search_per_page;
                    this.perRow = this.loggedInUser.search_settings.vehicle_search_per_row;
                }
            },
            async getData(cache_key) {
                const afterLoaded = ()  => {
                    if (this.$router && this.$router.lastScrollPosition) {
                        this.$nextTick(() => {
                            if (this.$router.lastScrollPosition.y) {
                                document.documentElement.scrollTop = this.$router.lastScrollPosition.y;
                            }
                        })
                    }
                    this.setLoading(false);
                }
                const onError = (err) => {
                    this.setLoading(false)
                    console.warn('there was a problem loading the vehicles', err)
                }
                const loadVehicles = (response) => {
                    let ids = [];
                    let favourites = []
                    let vehicles = response.results.results
                    this.$_.each(vehicles, item => {
                        item.showBox = false;
                        item.bidBox = false;
                        ids.push(item.api_id);
                        if (item.is_favourite) {
                            favourites.push(item.api_id)
                        }
                    });
                    this.vehicleIds = ids
                    this.selectedVehicles = favourites;
                    this.addToNextPrevStack({ids});
                    this.results = vehicles;
                    this.resultCacheKey = response.cache_key;
                    this.totalRecords = response.results.total_count;
                }
                const retrieveData = (perpage, setviewed)  => {
                    return new Promise((resolve, reject) => {
                        let query_data = JSON.parse(JSON.stringify(data));
                        if (query_data.currentPage !== 1 && perpage !== query_data.perpage) { //
                            query_data.currentPage = (query_data.perpage / perpage) * (query_data.currentPage - 1) + 1
                        }
                        query_data.perpage = perpage
                        query_data.setviewed = setviewed ? 'y' : 'n'
                        let url = '/search-pagination?' + objToUrl(query_data);
                        if (this.dataRetrievalCancelTokenSource) {
                            this.dataRetrievalCancelTokenSource.cancel('Request cancelled')
                        }
                        this.dataRetrievalCancelTokenSource = this.axios.CancelToken.source();
                        this.axios.get(url, { cancelToken: this.dataRetrievalCancelTokenSource.token }).then(response => {
                            if ('/auctions/search' === window.location.pathname) {
                                if (response && response.data && response.data.results) {
                                    if (setviewed) {
                                        let query = JSON.parse(JSON.stringify(this.$route.query));
                                        query.cache_key = response.data.cache_key
                                        this.$router.replace({path: window.location.pathname, query})
                                        this.$route.query.cache_key = response.data.cache_key
                                    }
                                    resolve(response.data)
                                } else {
                                    reject(response)
                                }
                            } else {
                                reject('url has changed')
                            }
                        }).catch(error => {
                            reject(error)
                        });
                    })
                }

                let fieldData = '';
                if (this.searchFieldData) {
                    fieldData = this.searchFieldData
                } else {
                    fieldData = this.searchfields
                }
                if (fieldData.notviewedbefore) {
                    let jpntimenow = moment.tz(moment(), 'Asia/Tokyo')
                    let jpntime = moment.tz(fieldData.notviewedbefore, 'Asia/Tokyo')
                    let timemsg;
                    if (jpntimenow.format('DD') !== jpntime.format('DD')) {
                        timemsg = jpntime.format('Do MMM hh:mm A')
                    } else {
                        timemsg = jpntime.format('hh:mm A') //`10:20 PM JST.`
                    }
                    this.notSeenBefore = `Not seen before ${timemsg} JST.`
                } else {
                    this.notSeenBefore = false
                }
                //this.searchFieldData = this.searchFields
                let data = {
                    currentPage: this.currentPage,
                    searchFields: fieldData,
                    perpage: this.perPage,
                    per_row: this.perRow,
                    sortorder: this.sortOrderBy
                };
                if (cache_key) {
                    data.cache_key = cache_key;
                }
                this.setLoading(true);
                if (this.perPage > 50 && !cache_key) {
                    // doing it this way with promises to make both ajax calls run asyn and then if the 'all' query
                    // returns first for some reason, the first 50 call doesn't override the data.
                    let firstLoaded = false
                    let allLoaded = false
                    try {
                        const response = await retrieveData(50, false)
                        firstLoaded = true
                        if (!allLoaded) {
                            loadVehicles(response)
                        }
                        let perPage = this.perPage;
                        const allResponse = await retrieveData(perPage, true)
                        allLoaded = true
                        loadVehicles(allResponse)
                        afterLoaded()
                    } catch (e) {
                        if (!this.axios.isCancel(e)) {
                            onError(e)
                        }
                    }
                } else {
                    //check if we're here by using back button, if so then scroll to position
                    const state_key = window.history.state && window.history.state.key ? window.history.state.key : null;
                    if (state_key && this.$store.getters['auction_search/getSearchResultsStateKey'] === state_key) {
                        afterLoaded()
                        retrieveData(this.perPage, true).then(response => {
                            loadVehicles(response)
                        }).catch(onError)
                    } else {
                        retrieveData(this.perPage, true).then(response => {
                            loadVehicles(response)
                            afterLoaded()
                        }).catch(onError)
                    }
                }

            },
            showMax() {
                this.perPage = 500;
                this.endNumber = 500;
                this.startFrom = 1;
                this.setSearchSettings()
                this.getData();
            },
            selectVehicle(vehicle) {
                let selected = this.selectedVehicles.indexOf(vehicle.api_id);
                if (selected !== -1) {
                    this.selectedVehicles.splice(selected, 1);
                } else {
                    this.selectedVehicles.push(vehicle.api_id);
                }
            },
            isFavourite(vehicle_id) {
                let is_fav = false;
                if (this.favourites) {
                    this.favourites.forEach(fav => {
                        if (fav === vehicle_id) {
                            is_fav = true;
                        }
                    });
                }
                return is_fav;
            },
            getSortOrderBy: function () {
                this.currentPage = 1;
                if (this.sortOrderBy !== this.$route.query.sort_by) {
                    let query = JSON.parse(JSON.stringify(this.$route.query))
                    query.sort_by = this.sortOrderBy
                    let query_string = objToUrl(query);
                    let base_url = this.$laravelRouter('search-vehicle', [], false);
                    let url = base_url + '?' + query_string;
                    this.$router.replace(url);
                }
                this.getData();
            },
            onSearch(data) {
                for (var propName in data) {
                    if (data[propName] === null || data[propName] === undefined) {
                        delete data[propName];
                    }
                }
                this.searchFieldData = data;
                this.getData();
            },
            async submitBid(vehicle) {
                let args = {
                    landed_price: vehicle.bid_landed_cost,
                    api_id: vehicle.api_id,
                };
                try {
                    let result = await this.$store.dispatch('userBids/storeBid', args);
                    if (result.message) {
                        this.$message.success(result.message);
                        vehicle.currentUserBid = vehicle.bid_landed_cost;
                    }
                    vehicle.bid_landed_cost = '';
                } catch (e) {
                    handleHttpError(e);
                }
            },
            onBidEnter(vehicle, event) {
                if (event.key == "Enter") {
                    this.submitBid(vehicle);
                }
            },
            openSendEmailModal() {
                $('#sendEmail').modal('show');
                this.$store.dispatch('loadVehicleForEmail/getVehicle', {
                    vehicle_ids: this.vehicleIds,
                });
            },
            openFavouriteTagList(vehicle_id) {
                this.favListModalOpen = true;
                this.vehicle_id = vehicle_id;
                this.$store.dispatch('favouriteTags/maybeGetTags', {});
            },
            tagPopupModal(vehicle_id) {
                this.openFavouriteTagList(vehicle_id);
            },
            async addAutoNotice() {
                let args = {...this.searchfields};
                if (args.id) {
                    delete args.id
                }
                args.name = 'Auto notice - ' + moment().format('YYYY-MM-DD');
                try {
                    let result = await this.$store.dispatch('auto_notices/save', args);
                    this.$message.success(result.message);
                } catch (e) {
                    let msg = getExceptionErrorMessage(e);
                    this.$message.error(msg);
                }
            },
        },
        watch: {
            pageParam (value) {
                if (value) {
                    this.$store.commit('auction_search/setCurrentPage', value)
                    this.getPagination()
                }
            }
        },
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/VehicleSearchList.vue